export default "__VITE_ASSET__Bnrq_6VZ__"